import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigManagerService } from './config-manager.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authToken: string | null = null;

  constructor(private http: HttpClient, private configManagerService: ConfigManagerService) {}

  autenticacao(tokenRecaptcha: string) {
    let objetoRecaptcha = { TokenRecaptcha: tokenRecaptcha };
    const urlAutenticacao = this.configManagerService.obterConfig()?.API_AUTENTICACAO;
    return this.http.post<any>(`${urlAutenticacao}/Autenticar`, objetoRecaptcha);
  }
}
